import { useModalArchivePropertyStore } from '../../../store'
import type { TPropertyBy } from '../../../../interfaces'

const OPTIONS_STEP_SOLD = [
  {
    value: 'BY_ME',
    label: 'Yo'
  },
  {
    value: 'BY_SAME_AGENCY_BROKER',
    label: 'Un asesor de mi inmobiliaria'
  },
  {
    value: 'BY_EXTERNAL_BROKER',
    label: 'Un asesor de otra inmobiliaria'
  }
] as const

interface IUseHandleSoldStep {
  setSelectedByOption: (option: TPropertyBy) => void
}

export const useHandleSoldStep = ({
  setSelectedByOption
}: IUseHandleSoldStep) => {
  const modalArchiveProperty = useModalArchivePropertyStore(
    (state) => state?.modalArchiveProperty
  )
  const propertiesSelectedLength = modalArchiveProperty?.propertiesIds?.length

  const propertyTitle = modalArchiveProperty?.title

  const titlePlural = `¿Quién rento/vendió las ${propertiesSelectedLength} propiedades?`

  const titleSingular = propertyTitle
    ? `¿Quién rento/vendió la propiedad "${propertyTitle}"?`
    : '¿Quién rento/vendió la propiedad?'

  const soldTitle = propertiesSelectedLength > 1 ? titlePlural : titleSingular

  const handleChangeByOption = (option: TPropertyBy) => {
    setSelectedByOption(option)
  }

  return {
    OPTIONS_STEP_SOLD,
    handleChangeByOption,
    soldTitle
  }
}
